import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { faGooglePlay } from "@fortawesome/free-brands-svg-icons";

export default function SharePage() {
  const { id } = useParams();

  const getAppLink = () => {
    const packageName = "com.getmovenew";
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // iOS: banner Apple App Store (meta tag gestisce)
      return `https://getmoveapp.com/Share/${id}`;
    } else if (/Android/i.test(navigator.userAgent)) {
      // Android: intent URL
      return `intent://Share/${id}#Intent;scheme=https;package=${packageName};S.browser_fallback_url=${encodeURIComponent(
        `https://play.google.com/store/apps/details?id=${packageName}`
      )};end`;
    } else {
      return `https://getmoveapp.com/Share/${id}`;
    }
  };

  return (
    <Container className="justify-content-center align-items-center text-center">
      <div>
        <img
          width={350}
          height={200}
          src={require("../assets/logo/logo.png")}
          alt="Get Move Logo"
        />
      </div>
      <h4>
        Sembra che tu abbia ricevuto un Link per entrare in Get Move, ma non hai
        ancora scaricato l'App
      </h4>
      <h5 className="mb-5">Scaricala subito per non perderti nessun contenuto!</h5>
      {!/iPhone|iPad|iPod/i.test(navigator.userAgent) && (
        <a
          style={{
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#1DB954", // colore principale
            color: "#fff",
            border: "none",
            borderRadius: 12,
            padding: "16px 20px",
            fontSize: 16,
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            marginTop: 16,
            transition: "transform 0.1s ease, box-shadow 0.2s ease",
            textDecoration: "none",
          }}
          href={getAppLink()}
        >
          <FontAwesomeIcon className="me-2" icon={faGooglePlay} />
          Scarica l'App
        </a>
      )}
    </Container>
  );
}
